import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LandingPageService } from 'src/app/core/services/landing-page.service';

@Component({
  selector: 'learn-more',
  templateUrl: './learn-more.component.html',
  styleUrls: ['./learn-more.component.scss']
})
export class LearnMoreComponent implements OnInit {



  public slug:string = location.href.split('#')[1]
  @Input() title: string
  @Input() content: string
  @Input() link: string
  @Input() router_link: string
  @Input() template: string
  //Spacing & Styles
  @Input() marginBottom: string
  @Input() bordered: boolean
  showTooltip: boolean = false;

  constructor(
    public lps:LandingPageService,
    private router: Router,
    ){

    }

    ngOnInit(): void {
      console.log("title", this.title)
      console.log("content", this.content)
      console.log("link", this.link)
      console.log("slug", this.slug)
    }

  public redirect(link:string) : void {
    console.log("link", link)
    if(link.includes('http')){
      // location.href = link;
      window.open(link, '_blank');
    }else{
      this.router.navigate([link]);
    }
  }

}
